import {Modal} from 'quickstart/components/layout/Modal'
import {Auth} from 'quickstart/components/tizra/Auth'
import {useAuthConfig} from 'quickstart/hooks'
import {SignInModalView, useSignInModalProps} from './useSignInModalProps'

interface SignInModalProps {
  authConfig: ReturnType<typeof useAuthConfig>
  store: ReturnType<typeof Modal.useStore>
  view: SignInModalView
}

const _SignInModal = ({authConfig, store, view}: SignInModalProps) => {
  const isOpen = store.useState('open')
  return (
    <Modal key="modal" size="sm" aria-label="sign in" store={store}>
      <Auth
        {...authConfig}
        autoFocus={
          // By passing open state here, the effect in Input will fire to focus
          // when the modal appears, otherwise it doesn't work.
          isOpen
        }
        modal={true}
        show={store.show}
        view={view}
      />
    </Modal>
  )
}

export const SignInModal = Object.assign(_SignInModal, {
  useProps: useSignInModalProps,
})
